import { MarketingTileSavePayload, MarketingTileSet } from './MarketingTypes';

const parseJson = async <T>(response: Response): Promise<T> => {
  const text = await response.text();
  if (!text) {
    return {} as T;
  }
  return JSON.parse(text) as T;
};

export class MarketingService {
  static async loadTiles(): Promise<MarketingTileSet> {
    const response = await fetch('/api/marketing/tiles', {
      method: 'GET',
      headers: { 'content-type': 'application/json' }
    });

    if (!response.ok) {
      throw new Error(`Marketing tiles request failed (${response.status})`);
    }

    return await parseJson<MarketingTileSet>(response);
  }

  static async saveTiles(payload: MarketingTileSavePayload): Promise<MarketingTileSet> {
    const response = await fetch('/api/marketing/tiles', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (response.status === 409) {
      const conflict = await parseJson<{ message?: string }>(response);
      throw new Error(conflict?.message || 'Marketing tiles were updated by someone else.');
    }

    if (!response.ok) {
      throw new Error(`Marketing tiles update failed (${response.status})`);
    }

    return await parseJson<MarketingTileSet>(response);
  }
}
